var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 100,
    height: 100,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1818 70.003H51.2727V57.6394L47.9391 51.8182L44 52.1848V67.8212C44 69.0266 44.9764 70.003 46.1818 70.003Z",
    fill: "#0085F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7273 70.003H73.8182C75.0237 70.003 76 69.0266 76 67.8212V52.1848L72.0666 51.8182L68.7274 57.6394V70.003H68.7273Z",
    fill: "#00A94B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7273 48.1847L65.7368 53.8912L68.7273 57.6393L76 52.1847V49.2757C76 46.5793 72.9218 45.0393 70.7636 46.6575L68.7273 48.1847Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2728 57.6393L48.4232 51.6199L51.2728 48.1847L60 54.7301L68.7273 48.1847V57.6393L60 64.1847L51.2728 57.6393Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 49.2757V52.1847L51.2727 57.6393V48.1847L49.2364 46.6575C47.0782 45.0393 44 46.5793 44 49.2757Z",
    fill: "#E51C19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_1208",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_1208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_1208",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.f1c9a8edde373ce6b13fe928300591ee.svg";
export { ForwardRef as ReactComponent };